export default __webpack_public_path__ + "static/Cover-f12c54a05b12fb2e864e384b61e6bee5.png";